import React from 'react';
import AdminChatItem from './AdminChatItem';

const AdminChatList = ({ chats, selectedChat, onSelectChat, loading }) => {
  if (loading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
        <p className='text-muted mt-2'>Loading chats...</p>
      </div>
    );
  }

  if (chats.length === 0) {
    return (
      <div className='text-center py-5'>
        <div className='text-muted'>
          <i className='bi bi-chat-dots' style={{ fontSize: '3rem' }}></i>
          <p className='mt-3'>No chats available</p>
        </div>
      </div>
    );
  }

  return (
    <div className='list-group list-group-flush'>
      {chats.map((chat) => (
        <AdminChatItem
          key={chat.id}
          chat={chat}
          isSelected={selectedChat?.id === chat.id}
          onSelect={() => onSelectChat(chat)}
        />
      ))}
    </div>
  );
};

export default AdminChatList;
